var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPmkLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 40,
    fill: "none",
    viewBox: "0 0 110 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M6.558 12.715c-1.151 4.696-3.543 12.138-.177 12.315 3.366.089 4.163-3.987 4.163-3.987S8.86 20.6 9.57 17.5c.177-.797.442-1.772.708-2.923 1.86.088 6.111.088 8.503-2.127 3.011-2.658 2.48-6.467.354-8.24C17.01 2.439 12.67.933 7.532 2.439 2.395 3.944.092 7.133.004 9.526c-.089 2.392 1.328 5.05 4.517 2.569-.886-1.683-.443-3.81 1.063-4.962.443-.354.974-.708 1.506-.974 0 2.215-.178 4.43-.532 6.556zm5.137-7.442h.62c1.86 0 3.897.975 3.897 3.367 0 2.303-2.922 3.632-5.402 3.72.53-2.303.885-4.695.885-7.087zM24.273 11.125c1.229 0 2.225-.996 2.225-2.225s-.996-2.225-2.225-2.225-2.225.996-2.225 2.225.996 2.225 2.225 2.225zM92.844 11.125c1.23 0 2.226-.996 2.226-2.225s-.997-2.225-2.225-2.225c-1.23 0-2.226.996-2.226 2.225s.997 2.225 2.225 2.225z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M82.774 19.262c.796 1.593-.354 4.867 1.945 5.663 1.68.53 3.27-.442 4.42-1.681.265.973 1.15 1.77 2.122 1.77 1.68.176 3.448-.885 4.774-2.124.796 1.416 2.298 2.212 3.89 2.123 1.149 0 2.21-.265 3.182-.796 1.238 1.947 4.155 0 4.155 0-.442-.53-.707-1.15-.884-1.77-.619-2.654 3.448-17.694 2.21-19.552-1.237-1.858-3.624-.62-3.624-.62v3.097c-.177 2.92-.531 5.75-1.149 8.582-.531-.442-1.238-.796-1.945-.796-3.537-.354-5.924 2.212-6.542 5.485-.089.796-.089 1.504 0 2.3-1.238 1.15-2.034 1.416-2.564.354-.707-1.504 1.856-5.662.619-7.431-1.238-1.77-3.625-.62-3.625-.62.177.531.265 1.062.177 1.593-.089 1.15-.707 3.981-.884 5.308v.089c-1.768 1.68-3.36 2.477-3.36.796 0-.885.266-1.858-.442-3.008-.707-.796-1.768-1.239-2.829-1.15 1.857-.708 3.625-.973 4.51-2.035.706-.885.795-2.124.087-3.097-.53-.62-1.68-.354-1.68-.354-.707 1.416-3.535 3.362-4.596 3.982.972-5.22 2.21-11.325 1.503-12.475-1.238-1.858-3.625-.62-3.625-.62v3.097c-.177 4.424-1.768 12.033-2.033 13.271-1.945 9.644 4.243 5.486 4.243 5.486-.442-.531-.707-1.15-.884-1.77-.088-1.239 0-2.566.265-3.804 1.061-.354 1.945-.62 2.564.707zm15.913-.619c.53-2.566 1.68-3.716 3.006-3.45 1.149.265 1.591 2.123 1.061 4.246-.531 2.124-1.503 3.716-2.653 3.54-1.149-.177-2.033-1.77-1.414-4.336zM107.262 28.479c-3.894-.088-14.427-.44-25.49-.528-3.187 0-8.852-.088-8.852-.088l2.833 3.165h7.7c14.25.175 25.58.527 25.58.527.531-.967.177-2.197-.797-2.725-.265-.175-.619-.263-.974-.351z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M72.95 27.84c.973-5.488 2.389-12.922 1.592-14.072-1.238-1.859-3.627-.62-3.627-.62v3.098c0 .442-.088.885-.088 1.327-.089 1.593-.974 3.098-2.3 3.983-.797.53-1.328.442-1.681-.354-.708-1.505 1.857-5.664.619-7.434-1.239-1.77-3.627-.62-3.627-.62.176.531.265 1.062.176 1.593-.088.974-.53 3.363-.796 4.78-1.858 2.035-3.185 3.097-3.892 1.68-.708-1.504 1.858-5.663.619-7.433-.442-.708-1.327-1.062-2.123-.974-.708 0-1.327.089-1.947.443-.884.442-1.769 1.15-2.388 1.947 0-.443-.089-.974-.354-1.416-1.239-1.859-3.627-.62-3.627-.62-.974.531-1.77 1.15-2.478 2.036 0-.531-.088-.974-.353-1.416-1.239-1.859-3.628-.62-3.628-.62.177.531.266 1.062.177 1.593-.088.974-.53 3.186-.796 4.602-2.035 2.213-4.158 3.54-4.158 1.593 0-.885.265-1.858-.442-3.009-.708-.796-1.77-1.239-2.831-1.15 1.857-.708 3.627-.974 4.511-2.036.708-.885.797-2.124.089-3.097-.53-.62-1.68-.354-1.68-.354-.709 1.416-3.54 3.363-4.601 3.982.973-5.221 2.211-11.328 1.504-12.478-1.239-1.858-3.628-.62-3.628-.62v3.098c-.177 4.425-1.769 12.036-2.034 13.275-.089.442-.177.796-.177 1.239-1.77 1.858-3.008 2.743-3.628 1.416-.707-1.505 1.858-5.664.62-7.434-1.239-1.77-3.627-.62-3.627-.62.176.531.265 1.062.176 1.593-.088 1.15-.707 3.983-.884 5.31-.177 1.328-.708 4.514 2.211 4.868 1.77.177 3.716-1.062 5.043-2.39.442 4.248 4.6 1.505 4.6 1.505-.442-.531-.707-1.15-.884-1.77-.089-1.24 0-2.567.265-3.806.974-.265 1.858-.62 2.566.708.796 1.593-.266 4.956 2.035 5.664 1.77.531 3.539-.62 4.689-2.035 0 1.593.796 2.92 4.07 1.593-.266-.62-.09-2.036.265-3.806.177-.885.619-3.009 1.504-3.894 1.061-1.15 1.68-.885 1.504.266-.177 1.15-.443 2.3-.531 3.009-.177 1.327-1.77 6.549 3.804 4.336-.354-.708 0-2.566.354-4.602.177-1.15.62-2.212 1.327-3.097 1.062-1.15 1.946-.885 1.858.265-.089 1.15-.354 2.39-.443 3.098-.177 1.327-.707 4.513 2.212 4.867 1.858.177 3.804-1.15 5.22-2.478 0 1.328.973 2.39 2.3 2.478 1.68.177 3.539-.973 4.866-2.212-.266 1.504-.531 3.894-.708 5.044h-.088c-14.952 0-52.286.62-62.99.797-2.478 0-4.424 1.947-4.513 4.336 0 .708.177 1.328.708 1.859 0 0 34.769-3.894 66.352-3.983-.442 2.478-.354 3.983 0 4.956.62 2.036 3.45 5.399 6.9 4.071 6.37-2.39 2.566-11.859-3.184-11.859zm1.592 9.026c-1.327.443-2.654-1.327-2.477-3.628.089-.62.177-1.416.266-2.301 3.715 0 4.246 5.221 2.211 5.93z",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.558 10.945c-1.151 4.696-3.543 12.138-.177 12.316 3.366.088 4.163-3.987 4.163-3.987S8.86 18.83 9.57 15.73c.177-.798.442-1.772.708-2.924 1.86.089 6.111.089 8.503-2.126 3.011-2.658 2.48-6.468.354-8.24C17.01.668 12.67-.838 7.532.668S.092 5.364.004 7.756c-.089 2.392 1.328 5.05 4.517 2.57-.886-1.684-.443-3.81 1.063-4.962.443-.355.974-.709 1.506-.975 0 2.215-.178 4.43-.532 6.556zm5.137-7.442h.62c1.86 0 3.897.975 3.897 3.367 0 2.304-2.922 3.632-5.402 3.721.53-2.303.885-4.696.885-7.088zM24.273 9.355c1.229 0 2.225-.996 2.225-2.225s-.996-2.225-2.225-2.225-2.225.996-2.225 2.225c0 1.23.996 2.225 2.225 2.225zM92.844 9.355c1.23 0 2.226-.996 2.226-2.225s-.997-2.225-2.225-2.225c-1.23 0-2.226.996-2.226 2.225 0 1.23.997 2.225 2.225 2.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.774 17.493c.796 1.592-.354 4.866 1.945 5.662 1.68.53 3.27-.442 4.42-1.681.265.973 1.15 1.77 2.122 1.77 1.68.176 3.448-.885 4.774-2.124.796 1.416 2.298 2.212 3.89 2.123 1.149 0 2.21-.265 3.182-.796 1.238 1.947 4.155 0 4.155 0-.442-.53-.707-1.15-.884-1.77-.619-2.654 3.448-17.694 2.21-19.552-1.237-1.858-3.624-.62-3.624-.62v3.097c-.177 2.92-.531 5.751-1.149 8.582-.531-.442-1.238-.796-1.945-.796-3.537-.354-5.924 2.212-6.542 5.485-.089.797-.089 1.504 0 2.3-1.238 1.15-2.034 1.416-2.564.355-.707-1.505 1.856-5.663.619-7.432-1.238-1.77-3.625-.62-3.625-.62.177.531.265 1.062.177 1.593-.089 1.15-.707 3.981-.884 5.308v.089c-1.768 1.68-3.36 2.477-3.36.796 0-.885.266-1.858-.442-3.008-.707-.796-1.768-1.239-2.829-1.15 1.857-.708 3.625-.973 4.51-2.035.706-.885.795-2.124.087-3.097-.53-.619-1.68-.354-1.68-.354-.707 1.416-3.535 3.362-4.596 3.982.972-5.22 2.21-11.325 1.503-12.475-1.238-1.858-3.625-.62-3.625-.62v3.097c-.177 4.424-1.768 12.033-2.033 13.271-1.945 9.644 4.243 5.486 4.243 5.486-.442-.531-.707-1.15-.884-1.77-.088-1.238 0-2.566.265-3.804 1.061-.354 1.945-.62 2.564.708zm15.913-.62c.53-2.565 1.68-3.716 3.006-3.45 1.149.265 1.591 2.123 1.061 4.247-.531 2.123-1.503 3.715-2.653 3.538-1.149-.176-2.033-1.769-1.414-4.335zM107.262 26.709c-3.894-.088-14.427-.44-25.49-.527-3.187 0-8.852-.088-8.852-.088l2.833 3.164h7.7c14.25.175 25.58.527 25.58.527.531-.967.177-2.197-.797-2.725-.265-.175-.619-.263-.974-.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M109.033 29.697c.531-.967.177-2.197-.797-2.724-.265-.176-.619-.264-.974-.264-3.894-.088-14.427-.44-25.49-.527-3.187 0-8.852-.088-8.852-.088l2.833 3.164h7.7c14.25.175 25.137.527 25.137.527",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.95 26.07c.973-5.488 2.389-12.921 1.592-14.072-1.238-1.858-3.627-.62-3.627-.62v3.098c0 .442-.088.885-.088 1.327-.089 1.593-.974 3.098-2.3 3.983-.797.531-1.328.442-1.681-.354-.708-1.505 1.857-5.664.619-7.434-1.239-1.77-3.627-.62-3.627-.62.176.531.265 1.063.176 1.594-.088.973-.53 3.362-.796 4.778-1.858 2.036-3.185 3.098-3.892 1.682-.708-1.505 1.858-5.664.619-7.434-.442-.708-1.327-1.062-2.123-.973-.708 0-1.327.088-1.947.442-.884.442-1.769 1.15-2.388 1.947 0-.442-.089-.973-.354-1.416-1.239-1.858-3.627-.62-3.627-.62-.974.531-1.77 1.151-2.478 2.036 0-.531-.088-.973-.353-1.416-1.239-1.858-3.628-.62-3.628-.62.177.531.266 1.063.177 1.594-.088.973-.53 3.185-.796 4.601-2.035 2.213-4.158 3.54-4.158 1.593 0-.884.265-1.858-.442-3.009-.708-.796-1.77-1.239-2.831-1.15 1.857-.708 3.627-.973 4.511-2.035.708-.886.797-2.124.089-3.098-.53-.62-1.68-.354-1.68-.354-.709 1.416-3.54 3.363-4.601 3.982.973-5.221 2.211-11.327 1.504-12.478-1.239-1.858-3.628-.62-3.628-.62v3.098c-.177 4.425-1.769 12.036-2.034 13.275-.089.442-.177.796-.177 1.239-1.77 1.859-3.008 2.744-3.628 1.416-.707-1.505 1.858-5.664.62-7.434-1.239-1.77-3.627-.62-3.627-.62.176.531.265 1.063.176 1.594-.088 1.15-.707 3.982-.884 5.31-.177 1.327-.708 4.513 2.211 4.867 1.77.177 3.716-1.062 5.043-2.39.442 4.248 4.6 1.505 4.6 1.505-.442-.531-.707-1.15-.884-1.77-.089-1.239 0-2.567.265-3.805.974-.266 1.858-.62 2.566.707.796 1.593-.266 4.956 2.035 5.665 1.77.53 3.539-.62 4.689-2.036 0 1.593.796 2.92 4.07 1.593-.266-.62-.09-2.035.265-3.805.177-.886.619-3.01 1.504-3.894 1.061-1.151 1.68-.886 1.504.265-.177 1.15-.443 2.301-.531 3.009-.177 1.327-1.77 6.549 3.804 4.336-.354-.707 0-2.566.354-4.602.177-1.15.62-2.212 1.327-3.097 1.062-1.15 1.946-.885 1.858.265-.089 1.151-.354 2.39-.443 3.098-.177 1.327-.707 4.513 2.212 4.867 1.858.178 3.804-1.15 5.22-2.477 0 1.327.973 2.389 2.3 2.478 1.68.177 3.539-.974 4.866-2.213-.266 1.505-.531 3.894-.708 5.044h-.088c-14.952 0-52.286.62-62.99.797-2.478 0-4.424 1.947-4.513 4.336 0 .708.177 1.328.708 1.859 0 0 34.769-3.894 66.352-3.983-.442 2.478-.354 3.983 0 4.956.62 2.036 3.45 5.399 6.9 4.071 6.37-2.39 2.566-11.859-3.184-11.859zm1.592 9.026c-1.327.443-2.654-1.327-2.477-3.628.089-.62.177-1.416.266-2.301 3.715 0 4.246 5.221 2.211 5.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M73.386 34.925c-1.068-.796-1.513-2.122-1.335-3.448.09-.619.178-1.415.267-2.299H68.67c-.445 2.387-.356 3.979 0 4.951.623 1.857 2.047 3.978 5.16 3.536l-.444-2.74z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M73.386 34.925c-1.068-.796-1.513-2.122-1.335-3.448.09-.619.178-1.415.267-2.299H68.67c-.445 2.387-.356 3.979 0 4.951.623 1.857 2.047 3.978 5.16 3.536l-.444-2.74z",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear)",
    d: "M25.241 19.436c-.353-.707.088-2.03.442-3.355l-4.151 1.854c0 .088 0 .265-.089.353-.176 1.324-.706 4.503 2.208 4.856 1.767.176 3.71-1.06 5.034-2.384 0-.883 0-1.854.089-2.737-1.678 1.942-2.915 2.825-3.533 1.413z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear)",
    d: "M59.312 19.43c-.354-.797.176-2.212.53-3.804l-4.329 3.096c-.176 1.504-.353 4.069 2.209 4.423 1.855.177 3.798-1.15 5.211-2.477-.088-.973 0-1.946.177-2.92-1.855 2.124-3.18 3.097-3.798 1.681z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear)",
    d: "M59.312 19.43c-.354-.797.176-2.212.53-3.804l-4.329 3.096c-.176 1.504-.353 4.069 2.209 4.423 1.855.177 3.798-1.15 5.211-2.477-.088-.973 0-1.946.177-2.92-1.855 2.124-3.18 3.097-3.798 1.681z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear)",
    d: "M85.745 19.187c0-.884.266-1.856-.443-3.005l-2.217 2.475c.177 1.679-.178 3.889 1.685 4.507 1.684.53 3.28-.442 4.434-1.679-.266-.972-.266-1.944-.09-2.917-1.773 1.591-3.369 2.387-3.369.62z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear)",
    d: "M85.745 19.187c0-.884.266-1.856-.443-3.005l-2.217 2.475c.177 1.679-.178 3.889 1.685 4.507 1.684.53 3.28-.442 4.434-1.679-.266-.972-.266-1.944-.09-2.917-1.773 1.591-3.369 2.387-3.369.62z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear)",
    d: "M96.132 21.104c-.356-.62-.533-1.329-.622-1.949-1.244 1.152-2.043 1.418-2.576.355-.355-.709.089-1.949.444-3.277l-4.174 2.125v.089l.088 2.923c.267.974 1.155 1.771 2.132 1.771 1.599.177 3.375-.886 4.707-2.037z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear)",
    d: "M96.991 22.2c.068.067.068.067 0 0z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear)",
    d: "M96.132 21.104c-.356-.62-.533-1.329-.622-1.949-1.244 1.152-2.043 1.418-2.576.355-.355-.709.089-1.949.444-3.277l-4.174 2.125v.089l.088 2.923c.267.974 1.155 1.771 2.132 1.771 1.599.177 3.375-.886 4.707-2.037z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear)",
    d: "M96.991 22.2c.068.067.068.067 0 0z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear)",
    d: "M38.152 19.189c.088-.796.088-1.503-.09-2.299l-2.664 1.326c.355 1.769-.177 4.333 1.777 4.863 1.776.53 3.552-.619 4.707-2.033l.444-3.449c-1.954 2.21-4.086 3.625-4.174 1.592z",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 62.426,
    x2: 81.599,
    y1: 27.939,
    y2: 27.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 66.117,
    x2: 72.287,
    y1: 27.105,
    y2: 34.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 71.1,
    x2: 71.1,
    y1: 21.745,
    y2: 32.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 29.933,
    x2: 23.514,
    y1: 24.742,
    y2: 18.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 64.04,
    x2: 60.613,
    y1: 24.489,
    y2: 21.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 62.513,
    x2: 58.034,
    y1: 23.137,
    y2: 18.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 91.144,
    x2: 87.547,
    y1: 25.217,
    y2: 21.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 89.388,
    x2: 84.099,
    y1: 22.998,
    y2: 18.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 97.635,
    x2: 94.147,
    y1: 25.316,
    y2: 21.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 98.431,
    x2: 95.762,
    y1: 23.639,
    y2: 20.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 97.913,
    x2: 91.245,
    y1: 25.593,
    y2: 18.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 97.096,
    x2: 97.042,
    y1: 22.234,
    y2: 22.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 43.566,
    x2: 37.549,
    y1: 24.318,
    y2: 18.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79297F",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B374A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H109.279V40H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmkLogo);
export default __webpack_public_path__ + "static/media/pmk-logo.a35b589e1f4f2f1503a2fe0590534f76.svg";
export { ForwardRef as ReactComponent };